module.exports = __webpack_public_path__ + "img/video_b.806799bf.svg";